import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M10.9756 13.5547C10.3585 14.1485 9.64061 14.1484 9.02148 13.5547L9.02344 13.5547C7.81597 12.3986 6.60863 11.2421 5.40527 10.082C4.81702 9.51583 4.87829 8.66559 5.53027 8.22168C6.03424 7.87839 6.69049 7.93411 7.15332 8.37012C7.62642 8.81598 8.09351 9.2699 8.5625 9.72168C8.61176 9.76896 8.65113 9.82573 8.69629 9.87891L8.75 9.85547L8.75 3.23437C8.75001 2.55767 9.26203 2.03057 9.93262 2.00098C10.6608 1.96946 11.247 2.50656 11.249 3.21875L11.249 9.9043C11.8105 9.36382 12.3252 8.85936 12.8496 8.36621C13.3762 7.87101 14.1578 7.87886 14.6494 8.37012C15.1162 8.83573 15.1184 9.54995 14.6475 10.0293C14.3842 10.2976 14.1065 10.5521 13.835 10.8125C12.8826 11.7259 11.93 12.6412 10.9756 13.5547ZM3.21484 18C2.54359 17.9999 2.00012 17.4564 2 16.7852C2 16.1138 2.54351 15.5704 3.21484 15.5703L16.7852 15.5703C17.4565 15.5704 18 16.1138 18 16.7852C17.9999 17.4564 17.4564 17.9999 16.7852 18L3.21484 18Z" })]
});
const ForwardRef = forwardRef(SvgDownload);
export default ForwardRef;
